package com.vamvisions.main.core.domain.preferences

enum class ColorScheme {
    LIGHT,
    DARK,
}
